import { getList, deleteSubscription, addNewSubscription, updateSubscription } from '../../repository/subscriptions/index';

const state = {
  subscriptionsList: null,
  dialogVisibility: false,
};

const getters = {
  subscriptionsList: store => store.subscriptionsList,
  dialogVisibility: store => store.dialogVisibility,
};

const mutations = {
  SET_SUBSCRIPTIONS_LIST(state, list) {
    state.subscriptionsList = list;
  },
  SET_DIALOG_VISBILITY(state, type) {
    state.dialogVisibility = type;
  },
};

const actions = {
  async getSubscriptionsList({ commit }, id) {
    commit('SET_SUBSCRIPTIONS_LIST', null);
    let subscriptionsList = await getList(id);
    subscriptionsList = subscriptionsList.data.data.items;
    commit('SET_SUBSCRIPTIONS_LIST', subscriptionsList);
  },
  setDialogVisbility({ commit }, type) {
    commit('SET_DIALOG_VISBILITY', type);
  },
  async subscriptionDelete({ dispatch }, data) {
    await deleteSubscription(data.subscriptionId);
    await dispatch('getSubscriptionsList', data.userId);
  },
  async subscriptionAdd({ dispatch }, data) {
    await addNewSubscription(data);
    await dispatch('getSubscriptionsList', data.client_id);
  },
  async subscriptionUpdate({ dispatch }, data) {
    await updateSubscription(data.data, data.id);
    await dispatch('getSubscriptionsList', data.clientId);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
